import { LegacyRoutes } from './portal-routes';

/**
 * Entry of the portal into the classic (Legacy) basket. Opened without it, the classic basket counts as a deeplink
 * and Legacy hands it over to the Shell (`ClassicBasketDeeplink`). The token is the base64 encoded current time;
 * Legacy accepts it only for a few minutes and removes it from the address, so it cannot be bookmarked.
 * Mirrors `classic-basket-deeplink.ts` in Legacy (TecWeb) and `ClassicBasketLinkHelper` in Order Pro.
 */
export const CLASSIC_BASKET_ENTRY_PARAM = 'entry';

/** The classic basket pages, relative to `/newapp`: its page and the Legacy route root, which redirects to it. */
export const CLASSIC_BASKET_PAGES: readonly string[] = ['/requestorder', LegacyRoutes.basket];

/** Adds a fresh entry token to a classic basket URL; create it right before the user is sent there. */
export function withClassicBasketEntry(classicBasketUrl: string): string {
  const url = new URL(classicBasketUrl);
  url.searchParams.set(CLASSIC_BASKET_ENTRY_PARAM, btoa(String(Date.now())));
  return url.toString();
}
